import Yygl from './yygl'
import zbFile from './zb-file'
import zbgg from './zbgg'
import fbyqs from './fbyqs'
import wjxz from './wen-jian-xie-zuo'
export default {
    path: 'fabiao',
    component: () => import(/*webpackChunkName: 'bidding-fabiao'*/ '@layout/empty'),
    children: [
        Yygl,
        zbFile,
        zbgg,
        fbyqs,
        wjxz

    ]
}